// Components
import { Button } from '@mui/material';

// Core
import { renderColor } from '../../../core/utils';

const ButtonCustom = ({
  text = '',
  onClick = () => null,
  variant = 'contained',
  className = '',
  startIcon = null,
  endIcon = null,
  disabled = false,
  typeColor = 'primary',
  textTransform = 'none',
  width = '',
  height = '',
  type = 'button',
}) => {
  return (
    <Button
      type={type}
      color="primary"
      variant={variant}
      onClick={onClick}
      className={`fontPSemiBold px-4 hover:opacity-85 ${className}`}
      startIcon={startIcon}
      endIcon={endIcon}
      disabled={disabled}
      sx={{
        textTransform: textTransform,
        backgroundColor:
          variant === 'contained' && !disabled
            ? renderColor(typeColor)
            : undefined,
        borderColor:
          (variant === 'outlined' || variant === 'text') && !disabled
            ? renderColor(typeColor)
            : undefined,
        color:
          (variant === 'outlined' || variant === 'text') && !disabled
            ? renderColor(typeColor)
            : undefined,
        borderRadius: '100px',
        fontSize: '16px',
        boxShadow: 'none',
        width: width ? width : 120,
        height: height ? height : 50,
        padding: '9px 16px',
        '&:hover': {
          backgroundColor:
            variant === 'contained' && !disabled
              ? `${renderColor(typeColor)}`
              : (variant === 'outlined' || variant === 'text') && !disabled
                ? `${renderColor(typeColor)}0F`
                : undefined,
          borderColor:
            (variant === 'outlined' || variant === 'text') && !disabled
              ? renderColor(typeColor)
              : undefined,
        },
      }}
    >
      {text}
    </Button>
  );
};

export default ButtonCustom;
